<template>
  <div>
    <div v-if="totem">
      <div v-if="loaded">
        <div v-if="totem.ativo">
          <div
            class="row m-0 p-0"
            style="min-height: 100vh; max-height: 100vh"
            v-if="step !== 3"
          >
            <div
              :class="
                'col-md-12 d-flex ' +
                (totem.header ? '' : 'justify-content-center')
              "
              :style="
                'background:' +
                (totem.degrade
                  ? 'radial-gradient(' +
                    totem.cor +
                    ' 0%, ' +
                    totem.cor +
                    ' 30%, #ccc 100%)'
                  : totem.cor) +
                '; flex-direction: column;'
              "
            >
              <div
                class="row justify-content-center"
                style="
                  display: flex !important;
                  align-content: center !important;
                  min-height: 70vh;
                "
                v-if="step === 0 && totem.disposicao !== 2"
                id="step0"
                @click="
                  stepReset();
                  step++;
                "
              >
                <img
                  :src="totem.img_descanso ? totem.img_descanso : ''"
                  style="
                    min-width: 100vw;
                    min-height: 100vh;
                    max-width: 100vw;
                    max-height: 100vh;
                  "
                />
              </div>
              <div
                :class="
                  totem.header ? 'row text-center align-items-center' : 'd-none'
                "
                style="height: 15vh; width: 100vw"
                :style="'background: ' + totem.background_header + ';'"
                v-if="step > 0 || totem.disposicao === 2"
              >
                <div :class="totem.relogio ? 'col-md-3 text-left' : 'd-none'">
                  <h5
                    style="font-weight: 500"
                    :style="
                      'font-size: ' +
                      totem.fonte_relogio +
                      'vh; color: ' +
                      totem.color_header +
                      '!important;'
                    "
                  >
                    <b>Horário:</b> {{ data }} {{ hora }}
                  </h5>
                  <h5
                    style="font-weight: 500"
                    :style="'color: ' + totem.color_header + '!important;'"
                    v-show="document.nome"
                  >
                    <b v-if="totem.disposicao !== 2"
                      >{{ configuracao.tipo_pessoa }}:</b
                    ><br />{{ document.nome }}
                  </h5>
                </div>
                <div
                  :class="totem.relogio ? 'col-md-6' : 'offset-md-3 col-md-6'"
                >
                  <h2
                    :style="
                      'font-size: ' +
                      totem.fonte_header +
                      'vh; color: ' +
                      totem.color_header +
                      '!important;'
                    "
                  >
                    {{ totem.mensagem_central }}
                  </h2>
                </div>
                <div
                  :class="
                    totem.header
                      ? 'col-md-3 d-flex justify-content-end'
                      : 'd-none'
                  "
                >
                  <img
                    :src="totem.logo_pronta"
                    v-if="totem.logo"
                    style="max-height: 10vh; max-width: 100%"
                    class="mr-4"
                    @click="clickLogo"
                  />
                  <h1
                    style="
                      border: 1px solid black;
                      padding: 1vh;
                      color: black !important;
                    "
                    v-else
                  >
                    LOGO
                  </h1>
                </div>
              </div>
              <div class="row" v-if="totem.disposicao === 2 && step === 0">
                <div
                  class="col-7"
                  style="
                    display: flex !important;
                    align-content: center !important;
                    min-height: 70vh;
                  "
                  v-if="totem.video_totem"
                >
                  <video
                    class="mt-1"
                    :src="totem.video_totem.video_link"
                    style="background: #000000; width: 100%"
                    autoplay
                    muted
                    loop
                  ></video>
                </div>
                <div
                  :class="
                    totem.video_totem
                      ? 'offset-1 col-4 row justify-content-center'
                      : 'col-12 row justify-content-center'
                  "
                  style="
                    display: flex !important;
                    align-content: center !important;
                    min-height: 70vh;
                  "
                >
                  <div
                    class="col-10 d-flex justify-content-center align-items-center flex-column"
                    style="margin-top: 7px"
                  >
                    <div class="mb-1">
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn"
                          :class="
                            tipoDoc === 'cpf'
                              ? 'btn-primary'
                              : 'btn-outline-primary'
                          "
                          @click="alterarTipoDoc('cpf')"
                        >
                          CPF
                        </button>
                        <button
                          type="button"
                          class="btn"
                          :class="
                            tipoDoc === 'cns'
                              ? 'btn-primary'
                              : 'btn-outline-primary'
                          "
                          @click="alterarTipoDoc('cns')"
                        >
                          CNS
                        </button>
                      </div>
                    </div>
                    <h4 class="text-center">Digite abaixo seu documento</h4>
                    <div class="d-flex justify-content-center input-group mb-1">
                      <input
                        type="text"
                        class="form-control"
                        :style="totem.video_totem ? '' : 'max-width: 30%;'"
                        :value="documentoFormatado"
                        disabled
                      />
                      <!-- v-show="tipoDoc === 'CPF'" -->
                      <!-- <input
                        type="text"
                        class="form-control"
                        v-mask="'99999999999 9999'"
                        v-model="documento"
                        v-show="tipoDoc === 'CNS'"
                        disabled
                      /> -->
                    </div>
                    <span
                      class="text-center text-primary"
                      style="font-size: 0.8vw"
                    >
                      <i class="fas fa-info-circle"></i> Ao utilizar a
                      identificação por
                      {{ tipoDoc === "cpf" ? "CPF" : "CNS" }} você concorda em
                      compartilhar seus dados
                    </span>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-center align-itens-center"
                  >
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(1)"
                    >
                      <b style="font-size: 4.5vh">1</b>
                    </button>
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(2)"
                    >
                      <b style="font-size: 4.5vh">2</b>
                    </button>
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(3)"
                    >
                      <b style="font-size: 4.5vh">3</b>
                    </button>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-center align-itens-center"
                  >
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(4)"
                    >
                      <b style="font-size: 4.5vh">4</b>
                    </button>
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(5)"
                    >
                      <b style="font-size: 4.5vh">5</b>
                    </button>
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(6)"
                    >
                      <b style="font-size: 4.5vh">6</b>
                    </button>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-center align-itens-center"
                  >
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(7)"
                    >
                      <b style="font-size: 4.5vh">7</b>
                    </button>
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(8)"
                    >
                      <b style="font-size: 4.5vh">8</b>
                    </button>
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(9)"
                    >
                      <b style="font-size: 4.5vh">9</b>
                    </button>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-center align-itens-center"
                  >
                    <button
                      class="btn btn-danger mr-1 mb-1 py-2 px-1"
                      @click="deleteDoc()"
                    >
                      <b style="font-size: 4.5vh"
                        ><i class="fas fa-eraser"></i
                      ></b>
                    </button>
                    <button
                      class="btn btn-secondary mr-1 mb-1 p-2"
                      @click="inputDoc(0)"
                    >
                      <b style="font-size: 4.5vh">0</b>
                    </button>
                    <button
                      class="btn btn-success mr-1 mb-1 py-2 px-1"
                      @click="getPessoa()"
                      :disabled="!documentoValido"
                    >
                      <!-- :disabled="documento.length === 11 ? false : true" -->
                      <b style="font-size: 4.5vh"
                        ><i class="fas fa-check"></i
                      ></b>
                    </button>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-center align-itens-center"
                  >
                    <button
                      class="btn btn-primary mb-1 mr-1 px-2"
                      @click="getFacial()"
                      data-toggle="modal"
                      data-target="#reconhecimentoFacial2"
                      v-show="totem.biometria"
                    >
                      <b style="font-size: 2vh">Identificar via biometria</b>
                    </button>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-center align-itens-center"
                  >
                    <button
                      class="btn btn-primary mr-1 px-2"
                      @click="
                        getBotoesTotems();
                        step++;
                      "
                    >
                      <b style="font-size: 1.9vh">Entrar sem identificação</b>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="row justify-content-center"
                style="
                  display: flex !important;
                  align-content: center !important;
                  min-height: 70vh;
                "
                v-if="identifing && !search"
                id="identify"
              >
                <div class="text-center col-md-12 my-1">
                  <button
                    :class="'btn btn-' + (identifing ? 'danger' : 'dark')"
                    @click="identifing = !identifing"
                    v-show="
                      totem.disposicao !== 2 &&
                      !document.nome &&
                      !document.nome &&
                      totem.informa_documento
                    "
                  >
                    <b>{{ identifing ? "Cancelar" : "Informar Documento" }}</b>
                  </button>
                </div>
                <div class="col-4 mb-1">
                  <h4>Digite abaixo seu documento</h4>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-mask="'999.999.999-99'"
                      v-model="documento"
                      maxlength="15"
                      disabled
                    />
                    <!-- v-show="tipoDoc === 'CPF'" -->
                    <!-- <input
                    type="text"
                    class="form-control"
                    v-mask="'99999999999 9999'"
                    v-model="documento"
                    v-show="tipoDoc === 'CNS'"
                    disabled
                    /> -->
                  </div>
                  <span
                    class="text-center text-primary"
                    style="font-size: 0.8vw"
                    ><i class="fas fa-info-circle"></i> Ao utilizar a
                    identificação por CPF você concorda em compartilhar seus
                    dados</span
                  >
                </div>
                <div
                  class="col-12 d-flex justify-content-center align-itens-center"
                >
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(1)"
                  >
                    <b style="font-size: 4.5vh">1</b>
                  </button>
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(2)"
                  >
                    <b style="font-size: 4.5vh">2</b>
                  </button>
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(3)"
                  >
                    <b style="font-size: 4.5vh">3</b>
                  </button>
                </div>
                <div
                  class="col-12 d-flex justify-content-center align-itens-center"
                >
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(4)"
                  >
                    <b style="font-size: 4.5vh">4</b>
                  </button>
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(5)"
                  >
                    <b style="font-size: 4.5vh">5</b>
                  </button>
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(6)"
                  >
                    <b style="font-size: 4.5vh">6</b>
                  </button>
                </div>
                <div
                  class="col-12 d-flex justify-content-center align-itens-center"
                >
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(7)"
                  >
                    <b style="font-size: 4.5vh">7</b>
                  </button>
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(8)"
                  >
                    <b style="font-size: 4.5vh">8</b>
                  </button>
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(9)"
                  >
                    <b style="font-size: 4.5vh">9</b>
                  </button>
                </div>
                <div
                  class="col-12 d-flex justify-content-center align-itens-center"
                >
                  <button
                    class="btn btn-danger mr-1 mb-1 py-2 px-1"
                    @click="deleteDoc()"
                  >
                    <b style="font-size: 4.5vh"
                      ><i class="fas fa-eraser"></i
                    ></b>
                  </button>
                  <button
                    class="btn btn-secondary mr-1 mb-1 p-2"
                    @click="inputDoc(0)"
                  >
                    <b style="font-size: 4.5vh">0</b>
                  </button>
                  <button
                    class="btn btn-success mr-1 mb-1 py-2 px-1"
                    @click="getPessoa()"
                  >
                    <b style="font-size: 4.5vh"><i class="fas fa-check"></i></b>
                  </button>
                </div>
              </div>
              <div
                class="modal fade"
                id="modalAgenda"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modalAgenda"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div
                    class="modal-content"
                    style="width: 65vw; margin-left: -15vw; margin-top: -15vh"
                  >
                    <div
                      class="modal-header"
                      style="width: 65vw"
                      :style="
                        'background: ' +
                        (totem.background_header
                          ? totem.background_header
                          : '#15488a') +
                        ';' +
                        'color: ' +
                        (totem.color_header ? totem.color_header : '#ffffff') +
                        ';'
                      "
                    >
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div
                        class="row justify-content-center"
                        style="width: 65vw"
                      >
                        <h3 class="text-center" id="exampleModalLongTitle">
                          <b>Você possui agendamentos próximos!</b>
                        </h3>
                        <h5 class="mb-5">
                          Deseja retirar a senha e ser encaminhado direto ao
                          setor do seu agendamento? clique no agendamento
                          desejado para prosseguir
                        </h5>
                        <div class="row">
                          <div class="col-md-12">
                            <h4>Selecione a prioridade abaixo:</h4>
                          </div>
                        </div>
                        <div
                          class="col-md-6 d-flex justify-content-center mb-2"
                          v-for="(data, index) in agenda"
                          :key="index"
                        >
                          <button
                            :class="
                              'btn btn-block ' +
                              (data.status == 1
                                ? 'btn-border'
                                : data.status == 3 || data.status == 4
                                ? 'btn-border'
                                : 'btn-border')
                            "
                          >
                            <span
                              ><b>{{ data.nome }}</b></span
                            ><br />
                            <span
                              ><b>{{ data.data_agendado_f }}</b></span
                            ><br /><br />
                            <span>{{ data.descricao }}</span>
                          </button>
                        </div>
                        <div class="col-md-12 mb-1 text-center">
                          <div class="row">
                            <div class="col-md-4">
                              <button
                                class="btn btn-comum btn-block"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="
                                  (prioridade_atual = 1),
                                    pessoaPresente(agenda[0])
                                "
                              >
                                Comum
                              </button>
                            </div>
                            <div class="col-md-4">
                              <button
                                class="btn btn-preferencial btn-block"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="
                                  (prioridade_atual = 2),
                                    pessoaPresente(agenda[0])
                                "
                              >
                                Preferencial
                              </button>
                            </div>
                            <div class="col-md-4">
                              <button
                                class="btn btn-preferencial80 btn-block"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="
                                  (prioridade_atual = 3),
                                    pessoaPresente(agenda[0])
                                "
                              >
                                Preferencial +80
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="modal fade"
                id="reconhecimentoFacial2"
                tabindex="-1"
                role="dialog"
                aria-labelledby="reconhecimentoFacial2Label"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div
                      class="modal-header"
                      :style="
                        'background: ' +
                        (totem.background_header
                          ? totem.background_header
                          : '#15488a') +
                        ';' +
                        'color: ' +
                        (totem.color_header ? totem.color_header : '#ffffff') +
                        ';'
                      "
                    >
                      <h5
                        :style="
                          'color: ' +
                          (totem.color_header
                            ? totem.color_header
                            : '#ffffff') +
                          ';'
                        "
                        class="modal-title"
                        id="reconhecimentoFacial2Label"
                      >
                        Reconhecimento facial
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-12">
                          <div
                            class="alert alert-primary text-start"
                            style="font-size: 8.1pt; padding: 4px 0 4px 4px"
                            role="alert"
                          >
                            <i class="fa fa-info-circle"></i> Ao utilizar o
                            serviço de identificação biométrica, você concorda
                            com o uso de sua imagem.
                          </div>
                          <div
                            class="alert alert-primary text-start"
                            style="font-size: 8.2pt; padding: 4px 0 4px 4px"
                            role="alert"
                          >
                            <i class="fa fa-info-circle"></i> Seus dados não
                            serão expostos ou compartilhados com terceiros.
                          </div>
                          <video ref="camera2" autoplay width="100%"></video>
                          <canvas
                            ref="canvas2"
                            width="640"
                            height="480"
                            style="display: none"
                          ></canvas>
                        </div>
                        <div class="col-12 text-center my-1">
                          <button
                            class="btn btn-outline-primary"
                            @click="identificarFoto()"
                          >
                            Iniciar reconhecimento facial
                          </button>

                          <div
                            class="alert alert-danger mt-2 p-1 text-center"
                            role="alert"
                            v-show="reconhecido"
                          >
                            Não reconhecido
                          </div>
                          <div
                            class="alert alert-secondary mt-2 p-1 text-center"
                            role="alert"
                            v-show="carregando"
                          >
                            Carregando...
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="modal fade"
                id="reconhecimentoFacial"
                tabindex="-1"
                role="dialog"
                aria-labelledby="reconhecimentoFacialLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div
                      class="modal-header"
                      :style="
                        'background: ' +
                        (totem.background_header
                          ? totem.background_header
                          : '#15488a') +
                        ';' +
                        'color: ' +
                        (totem.color_header ? totem.color_header : '#ffffff') +
                        ';'
                      "
                    >
                      <h5
                        :style="
                          'color: ' +
                          (totem.color_header
                            ? totem.color_header
                            : '#ffffff') +
                          ';'
                        "
                        class="modal-title"
                        id="reconhecimentoFacialLabel"
                      >
                        Reconhecimento facial
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-12">
                          <video ref="camera" autoplay width="100%"></video>
                          <canvas
                            ref="canvas"
                            width="640"
                            height="480"
                            style="display: none"
                          ></canvas>
                        </div>
                        <div class="col-12 text-center my-1">
                          <button
                            class="btn btn-outline-primary"
                            @click="tirarFoto()"
                          >
                            Iniciar reconhecimento facial
                          </button>
                          <div
                            class="alert alert-danger mt-2 p-1 text-center"
                            role="alert"
                            v-show="reconhecido"
                          >
                            Não reconhecido
                          </div>
                          <div
                            class="alert alert-secondary mt-2 p-1 text-center"
                            role="alert"
                            v-show="carregando"
                          >
                            Carregando...
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" v-if="identifing && search">
                <div
                  class="d-flex justify-content-center align-items-center"
                  style="min-height: 40vh"
                >
                  <h2>Carregando, por favor aguarde...</h2>
                </div>
              </div>
              <div
                class="row justify-content-center"
                style="
                  display: flex !important;
                  align-content: start !important;
                  min-height: 70vh;
                "
                v-if="step === 1 && !identifing"
                id="step1"
              >
                <div class="text-center col-md-12 my-1">
                  <button
                    :class="'btn btn-' + (identifing ? 'danger' : 'dark')"
                    @click="identifing = !identifing"
                    v-show="
                      totem.disposicao !== 2 &&
                      !document.nome &&
                      totem.informa_documento
                    "
                  >
                    <b>{{ identifing ? "Cancelar" : "Informar Documento" }}</b>
                  </button>
                </div>
                <button
                  v-for="botao in botoes"
                  :key="botao.id"
                  :class="
                    'btn d-flex ' +
                    (botao.simbolo_id
                      ? 'justify-content-between'
                      : 'justify-content-center') +
                    ' align-items-center mx-2 ' +
                    (botoes.length > 14 ? ' mt-1 ' : ' mt-2 ') +
                    (totem.disposicao
                      ? botoes.length > 7
                        ? 'col-md-3'
                        : botoes.length > 3
                        ? 'col-md-5'
                        : 'col-md-8'
                      : 'col-md-3')
                  "
                  :style="
                    (totem.disposicao
                      ? botoes.length > 7
                        ? 'font-size: 1.8vh;'
                        : botoes.length > 3
                        ? 'font-size: 3.5vh;'
                        : 'font-size: 5vh;'
                      : 'font-size: 2.5vh;') +
                    ' border-radius:' +
                    (botoes.length > 14
                      ? totem.arredondamento * 2
                      : totem.arredondamento) +
                    'px;' +
                    'background:' +
                    botao.cor +
                    '; color: ' +
                    botao.cor_texto +
                    ';' +
                    (botoes.length > 14
                      ? 'height: 6vh;'
                      : totem.disposicao != 1
                      ? 'height: 10vh;'
                      : 'height: 10vh;')
                  "
                  @click="
                    botaoSelecionado = botao;
                    getBotoesFilhosTotem(
                      botao.id,
                      botao.preferencial,
                      botao.prefixo_senha,
                      botao.concatena_prefixo
                    )
                  "
                  :disabled="doubleClick"
                >
                  {{ botao.nome }}
                  <img
                    :class="botao.simbolo_id ? '' : 'd-none'"
                    :src="botao.simbolo.photo"
                    height="100%"
                    v-if="botao.simbolo"
                  />
                </button>
                <button
                  :class="
                    'btn d-flex justify-content-center' +
                    ' align-items-center mx-2 ' +
                    (botoes.length > 14 ? ' mt-1 ' : ' mt-2 ') +
                    (totem.disposicao
                      ? botoes.length > 7
                        ? 'col-md-3'
                        : botoes.length > 3
                        ? 'col-md-5'
                        : 'col-md-8'
                      : 'col-md-3')
                  "
                  :style="
                    (totem.disposicao
                      ? botoes.length > 7
                        ? 'font-size: 1.8vh;'
                        : botoes.length > 3
                        ? 'font-size: 3.5vh;'
                        : 'font-size: 5vh;'
                      : 'font-size: 2.5vh;') +
                    ' border-radius:' +
                    totem.arredondamento +
                    'px; background: #0a732c; color: #ffffff;' +
                    (botoes.length > 14
                      ? 'height: 6vh;'
                      : totem.disposicao != 1
                      ? 'height: 10vh;'
                      : 'height: 10vh;')
                  "
                  v-if="configuracao.pesquisa && !primeira_tela"
                  @click="getPesquisa()"
                >
                  Pesquisa de satisfação
                </button>
                <div
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myLargeModalLabel"
                  aria-hidden="true"
                  id="pesquisa_satisfacao"
                >
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header" style="background: #0a732c">
                        <h5 class="modal-title" style="color: #ffffff">
                          Pesquisa de satisfação
                        </h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <iframe
                              :src="configuracao.link_pesquisa"
                              style="
                                width: 100%;
                                min-height: 80vh;
                                overflow: hidden;
                              "
                              v-if="modalLoaded"
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="btn col-md-10 text-center mt-2 mx-2"
                  :style="
                    'position: absolute; bottom: 5%; font-size: 5vh; border-radius:' +
                    totem.arredondamento +
                    'px; background: #aaaaaa; color: #ffffff;' +
                    (totem.disposicao === 0 ? 'height: 10vh;' : 'height: 10vh;')
                  "
                  v-if="primeira_tela || totem.disposicao === 2"
                  @click="cancelar()"
                >
                  <!-- v-show="totem.tempo" -->
                  Cancelar
                </div>
              </div>
              <div
                class="row justify-content-center"
                style="min-height: 70vh; align-content: start"
                v-if="step === 4 && perguntaAtual"
                id="step4"
              >
                <div class="col-md-12 mt-3" v-if="resumoDasRespostas">
                  <div class="alert alert-light" style="font-size: 2.2vh">
                    <i class="fas fa-clipboard-list"></i>
                    {{ resumoDasRespostas }}
                  </div>
                </div>
                <div class="col-md-12 text-center my-3">
                  <h2 class="text-primary">{{ perguntaAtual.enunciado }}</h2>
                </div>
                <button
                  v-for="alternativa in alternativasDaPerguntaAtual"
                  :key="alternativa.id"
                  class="btn d-flex flex-column justify-content-center align-items-center mx-2 mt-2"
                  :class="alternativasDaPerguntaAtual.length > 6 ? 'col-md-3' : 'col-md-5'"
                  :style="
                    'height: 15vh; border-radius:' + totem.arredondamento + 'px;' +
                    (respostaDaPerguntaAtual.includes(alternativa.id)
                      ? 'background:#0a4d8c;color:#fff;'
                      : 'background:#f0f0f0;color:#0a4d8c;border:1px solid #0a4d8c;')
                  "
                  @click="alternarAlternativa(alternativa.id)"
                >
                  <img
                    v-if="alternativa.icone_url"
                    :src="alternativa.icone_url"
                    height="45"
                    class="mb-2"
                  />
                  <span style="font-size: 2.5vh">{{ alternativa.nome }}</span>
                </button>

                <div class="col-md-12 text-center mt-3" style="min-height: 8vh">
                  <span
                    v-if="respostaDaPerguntaAtual.length"
                    style="font-size: 2.5vh; color: #b8860b"
                  >
                    Selecionado(s): {{ nomesDaRespostaAtual }}
                  </span>
                </div>

                <div
                  class="col-md-12 d-flex justify-content-between mt-4"
                  style="position: absolute; bottom: 5%"
                >
                  <button
                    class="btn btn-secondary"
                    style="font-size: 3vh"
                    @click="cancelar()"
                  >
                    Cancelar
                  </button>
                  <button
                    class="btn btn-light"
                    style="font-size: 3vh"
                    v-if="indicePerguntaAtual > 0"
                    @click="voltarPergunta()"
                  >
                    &larr; Voltar
                  </button>
                  <button
                    class="btn btn-dark"
                    style="font-size: 3vh"
                    :disabled="!podeAvancarPergunta || doubleClick"
                    @click="avancarPergunta()"
                  >
                    {{ ehUltimaPergunta ? "Confirmar" : "Próximo" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row justify-content-center align-items-center m-0 p-0"
            v-else
          >
            <div
              class="col-8 d-flex flex-column justify-content-center align-items-center text-justify text-primary"
              style="min-height: 100vh; max-height: 100vh"
            >
              <span style="font-size: 20vh; line-height: 18vh">
                <span class="text-danger text-center">{{
                  senhaGerada.prefixo
                }}</span
                >{{ senhaGerada.senha }}
              </span>
              <span
                class="text-center"
                style="font-size: 5vh; line-height: 10vh"
                >{{ senhaGerada.setor }}</span
              >
              <span style="font-size: 4vh" class="mb-2"
                >Senha Retirada em {{ senhaGerada.data }}</span
              >
              <h4 class="text-primary text-center">
                {{ senhaGerada.mensagem }}
              </h4>
            </div>
          </div>
          <div
            class="modal fade"
            id="infoPessoa"
            tabindex="-1"
            role="dialog"
            aria-labelledby="infoPessoaTitle"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-lg modal-dialog-centered modal-xl"
              role="document"
            >
              <div class="modal-content">
                <div
                  class="modal-header"
                  :style="
                    'background: ' +
                    (totem.background_header
                      ? totem.background_header
                      : '#15488a') +
                    ';' +
                    'color: ' +
                    (totem.color_header ? totem.color_header : '#ffffff') +
                    ';'
                  "
                >
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12 centered">
                      <span
                        style="
                          font-size: 30px;
                          font-weight: bold;
                          text-transform: uppercase;
                        "
                        >Olá <span style="color: red">{{ document.nome }}</span
                        >, seja bem-vindo!</span
                      >
                    </div>
                    <!-- <div
                      class="col-md-12 centered"
                      style="
                        font-size: 20px;
                        text-transform: uppercase;
                        font-weight: bold;
                      "
                      v-if="!alterar"
                    >
                      Seu endereço atual é?
                    </div> -->
                  </div>
                  <div class="row" v-show="!alterar">
                    <div class="col-12">
                      <label><b>Nome:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="document.nome"
                        disabled
                      />
                    </div>
                    <div class="col-6">
                      <label><b>Nome da mãe:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="document.nomeMae"
                        disabled
                      />
                    </div>
                    <div class="col-6">
                      <label><b>Nome do pai:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="document.nomePai"
                        disabled
                      />
                    </div>
                    <!-- <div class="col-12">
                      <br />
                      <label><b>Endereço</b></label>
                    </div> -->
                    <!-- <div class="col-3">
                      <label><b>CEP:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.cep"
                        disabled
                      />
                    </div>
                    <div class="col-4">
                      <label><b>Tipo de endereço:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.tipo"
                        disabled
                      />
                    </div>
                    <div class="col-5">
                      <label><b>Logradouro:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.logradouro"
                        disabled
                      />
                    </div>
                    <div class="col-2">
                      <label><b>Número:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.numero"
                        disabled
                      />
                    </div>
                    <div class="col-3">
                      <label><b>Complemento:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.complemento"
                        disabled
                      />
                    </div>
                    <div class="col-4">
                      <label><b>Bairro:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.bairro"
                        disabled
                      />
                    </div>
                    <div class="col-3">
                      <label><b>Município:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.municipio"
                        disabled
                      />
                    </div>
                    <div class="col-2">
                      <label><b>UF:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.uf"
                        disabled
                      />
                    </div>
                    <div class="col-3">
                      <label><b>Telefone/Celular:</b></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="mock.telefone"
                        v-mask="'(99) 9 9999-9999'"
                        disabled
                      />
                    </div> -->
                  </div>
                  <!-- <div v-show="alterar">
                    <div
                      class="row d-flex justify-content-center"
                      align="center"
                    >
                      <div class="col-6 mt-2">
                        <label style="font-size: 20px"
                          ><b>Informe seu celular com WhatsApp:</b></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="mock.telefone"
                          v-mask="'(99) 9 9999-9999'"
                        />
                        <div>
                          <h1>&nbsp;</h1>
                        </div>
                        <div
                          class="col-12 d-flex justify-content-center align-itens-center"
                        >
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 1"
                          >
                            <b style="font-size: 4.5vh">1</b>
                          </button>
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 2"
                          >
                            <b style="font-size: 4.5vh">2</b>
                          </button>
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 3"
                          >
                            <b style="font-size: 4.5vh">3</b>
                          </button>
                        </div>
                        <div
                          class="col-12 d-flex justify-content-center align-itens-center"
                        >
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 4"
                          >
                            <b style="font-size: 4.5vh">4</b>
                          </button>
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 5"
                          >
                            <b style="font-size: 4.5vh">5</b>
                          </button>
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 6"
                          >
                            <b style="font-size: 4.5vh">6</b>
                          </button>
                        </div>
                        <div
                          class="col-12 d-flex justify-content-center align-itens-center"
                        >
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 7"
                          >
                            <b style="font-size: 4.5vh">7</b>
                          </button>
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 8"
                          >
                            <b style="font-size: 4.5vh">8</b>
                          </button>
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 9"
                          >
                            <b style="font-size: 4.5vh">9</b>
                          </button>
                        </div>
                        <div
                          class="col-12 d-flex justify-content-center align-itens-center"
                        >
                          <button
                            class="btn btn-danger mr-1 mb-1 py-2 px-1"
                            @click="mock.telefone = mock.telefone.slice(0, -1)"
                          >
                            <b style="font-size: 4vh"
                              ><i class="fas fa-eraser"></i
                            ></b>
                          </button>
                          <button
                            class="btn btn-secondary mr-1 mb-1 p-2"
                            @click="mock.telefone += 0"
                          >
                            <b style="font-size: 4.5vh">0</b>
                          </button>
                          <button
                            class="btn btn-success mr-1 mb-1 py-2 px-1"
                            @click="sendMessage()"
                            data-dismiss="modal"
                          >
                            <b style="font-size: 4vh"
                              ><i class="fas fa-check"></i
                            ></b>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="centered">
                  <button
                    type="button"
                    class="btn btn-secondary mr-3 mb-3 mt-2"
                    data-dismiss="modal"
                  >
                    Confirmar
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger mb-3 mt-2"
                    data-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="step !== 0 && step !== 3 && totem.tempo > 0 ? '' : 'd-none'"
            style="position: absolute; left: 8px; bottom: 8px"
            :style="
              'color: ' + totem.cor + ';' + totem.degrade
                ? 'filter: invert(0.75);'
                : 'filter: invert(0);'
            "
          >
            Tempo até voltar para o menu principal
            <b>{{ totem.tempo - timer }}</b> segundos
          </div>
        </div>
        <div
          class="d-flex justify-content-center align-items-center p-1"
          :style="
            'width: 100vw; height: 100vh; background:' +
            totem.cor +
            '; flex-direction: column;'
          "
          v-else
        >
          <h1 :style="'color:' + totem.cor_texto">TOTEM INATIVO</h1>
        </div>
      </div>
      <div
        class="d-flex justify-content-center align-items-center"
        style="min-height: 100vh"
        v-else
      >
        <h2>Carregando totem, por favor aguarde...</h2>
      </div>
    </div>
    <div
      class="d-flex justify-content-center align-items-center flex-column"
      v-else
      style="min-height: 100vh"
    >
      <div class="d-flex justify-content-center align-items-center">
        <h1>Esse totem não existe</h1>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <button class="btn btn-primary" @click="searchTotem()">
          Procurar totem <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";
import { BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  data() {
    return {
      carregando: false,
      reconhecido: false,
      agendaAtual: [],
      fotoUrl: null,
      clickCount: 0,
      clickTimeout: null,
      loaded: false,
      doubleClick: false,
      identifing: false,
      search: false,
      timer: 0,
      primeiroLoad: 0,
      tipoDoc: "cpf",
      reset: "",
      prefixo: "",
      totem: {},
      botoes: {},
      preferencial: 0,
      preferencial80: 0,
      data: "",
      hora: "",
      step: 0,
      botao_id: 0,
      configuracao: [],
      documento: "",
      document: {},
      senhaGerada: {
        prefixo: "",
        senha: "",
        setor: "",
        data: "",
        mensagem: "",
      },
      agenda: {},
      alterar: false,
      mock: {
        cep: "",
        tipo: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        municipio: "",
        uf: "",
        telefone: "",
      },
      setor_id: 0,
      prioridade_atual: 1,
      primeira_tela: 0,
      prefixo_concatena: 1, // Armazena se o pai permite concatenar com filho
      modalLoaded: false,
      modalOpen: false,
      agendaSetada: null,
      botoesCache: {}, // cache de botões por totem ID
      botaoSelecionado: null,
      perguntasDoQuestionario: [],
      indicePerguntaAtual: 0,
      respostasPorPergunta: {},
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
  },
  computed: {
    perguntaAtual() {
      return this.perguntasDoQuestionario[this.indicePerguntaAtual] || null;
    },
    alternativasDaPerguntaAtual() {
      const pergunta = this.perguntaAtual;

      if (!pergunta) {
        return [];
      }

      return (pergunta.alternativas_ativas || pergunta.alternativas || []).filter(
        (alternativa) => alternativa.ativo !== 0
      );
    },
    respostaDaPerguntaAtual() {
      const pergunta = this.perguntaAtual;

      return pergunta ? this.respostasPorPergunta[pergunta.id] || [] : [];
    },
    nomesDaRespostaAtual() {
      return this.alternativasDaPerguntaAtual
        .filter((alternativa) => this.respostaDaPerguntaAtual.includes(alternativa.id))
        .map((alternativa) => alternativa.nome)
        .join(", ");
    },
    podeAvancarPergunta() {
      const pergunta = this.perguntaAtual;

      if (!pergunta) {
        return false;
      }

      return pergunta.obrigatoria ? this.respostaDaPerguntaAtual.length > 0 : true;
    },
    ehUltimaPergunta() {
      return this.indicePerguntaAtual >= this.perguntasDoQuestionario.length - 1;
    },
    resumoDasRespostas() {
      return this.perguntasDoQuestionario
        .slice(0, this.indicePerguntaAtual)
        .map((pergunta) => {
          const respondidas = (pergunta.alternativas_ativas || pergunta.alternativas || [])
            .filter((alternativa) =>
              (this.respostasPorPergunta[pergunta.id] || []).includes(alternativa.id)
            )
            .map((alternativa) => alternativa.nome)
            .join(", ");

          return respondidas ? pergunta.enunciado + ": " + respondidas : "";
        })
        .filter((linha) => linha)
        .join("  |  ");
    },
    documentoFormatado() {
      if (!this.documento) return "";

      const doc = this.documento.replace(/\D/g, "").substring(0, 15);

      if (this.tipoDoc === "cpf") {
        // CPF: 999.999.999-99
        return doc
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      } else {
        // CNS: 999 9999 9999 9999
        return doc
          .replace(/(\d{3})(\d)/, "$1 $2")
          .replace(/(\d{4})(\d)/, "$1 $2")
          .replace(/(\d{4})(\d)/, "$1 $2");
      }
    },
    documentoValido() {
      const tamanho = this.documento.replace(/\D/g, "").length;

      if (this.tipoDoc === "cpf") {
        return tamanho === 11;
      } else if (this.tipoDoc === "cns") {
        return tamanho === 15;
      }

      return false;
    },
  },
  methods: {
    alterarTipoDoc(tipo) {
      this.tipoDoc = tipo;
      this.documento = ""; // Limpa o documento ao trocar
    },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";
      self.$loading(true);

      axios
        .post(api, {
          login: "sistemas@it4d.com.br",
          password: "SystemPass",
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          window.location.reload();
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message("Erro", error.response.data, "error");
        });
    },
    getTotem: function (id) {
      const self = this;

      var token = self.$store.state.token || localStorage.getItem("token");

      if (!token) {
        console.log("Token não encontrado, fazendo login...");
        self.login();
      }

      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      const api = self.$store.state.api + `totens/${id}?with[]=video_totem`;

      axios
        .get(api)
        .then((response) => {
          if (!response.data.data[0]) {
            self.totem = false;
          }

          self.totem = response.data.data[0];

          if (self.primeiroLoad === 0) {
            self.primeiroLoad++;

            if (self.totem.tempo < 1 && self.totem.disposicao != 2) {
              self.step = 1;
            }
          }

          self.loaded = true;

          self.refreshBotoes();
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            console.log("Token inválido, fazendo login novamente...");
            localStorage.removeItem("token");
            self.login();
          } else {
            self.$message(null, error.response.data, "error");
          }
        });
    },
    searchTotem: function () {
      const self = this;
      const api =
        self.$store.state.api + "totens?ativo=1&orderByDesc=created_at";

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          const totemId = response.data.data[0].id;
          self.getTotem(totemId);
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBotoes: function () {
      const self = this;

      self.botoes = [];

      self.$loading(true);

      axios
        .get(
          self.$store.state.api +
            "botoes?with[]=simbolo&ativo=1&orderByAsc=ordem&paginated=false"
        )
        .then((response) => {
          let i = 0;

          self.primeira_tela = 0;

          response.data.data.forEach((botao) => {
            if (!botao.botao_pai) {
              self.botoes[i] = botao;
              i++;
            }
          });

          self.$loading(false);
          self.doubleClick = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBotoesTotems: function () {
      const self = this;

      if (!self.totem || !self.totem.id) {
        console.log("Totem não carregado ainda, usando getBotoes padrão");
        self.getBotoes();
        return;
      }

      // Usa cache se disponível
      const cached = self.botoesCache[self.totem.id];
      if (cached && cached.length) {
        self.botoes = cached;
        self.primeira_tela = 0;
        self.doubleClick = false;
        return;
      }

      self.refreshBotoes();
    },
    refreshBotoes: function () {
      const self = this;

      if (!self.totem || !self.totem.id) {
        self.getBotoes();
        return;
      }

      self.botoes = [];
      self.$loading(true);

      axios
        .get(
          self.$store.state.api +
            `totens/${self.totem.id}/botoes?with[]=simbolo&ativo=1&orderByAsc=ordem&paginated=false`
        )
        .then((response) => {
          let i = 0;
          self.primeira_tela = 0;

          const botoesList = [];
          response.data.data.forEach((botao) => {
            if (!botao.botao_pai) {
              botoesList[i] = botao;
              i++;
            }
          });

          self.botoes = botoesList;
          self.botoesCache[self.totem.id] = botoesList;

          self.$loading(false);
          self.doubleClick = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getBotoesFilhosTotem: function (id, preferencial, prefixo, concatena) {
      const self = this;

      if (!self.totem || !self.totem.id) {
        console.log("Totem não carregado, usando método padrão");
        self.getBotoesFilhos(id, preferencial, prefixo, concatena);
        return;
      }

      const api =
        self.$store.state.api + `totens/${self.totem.id}/botoes-filhos/${id}`;

      self.primeira_tela++;

      // CLIQUE 1: Define prefixo do pai e salva se ele permite concatenar
      if (self.primeira_tela === 1) {
        self.prefixo = prefixo || "";
        self.prefixo_concatena = concatena; // Se concatena do pai = 0, não concatena com filho
      }
      // CLIQUE 2: Concatena prefixo do primeiro filho APENAS se o pai permite
      else if (self.primeira_tela === 2) {
        if (self.prefixo_concatena && prefixo) {
          self.prefixo += prefixo;
        }
      }
      // CLIQUE 3+: NÃO altera mais o prefixo

      if (preferencial > self.prioridade_atual) {
        self.prioridade_atual = preferencial;
      }

      self.botoes = [];
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          if (response.data.data.length) {
            let i = 0;
            response.data.data.forEach((botao) => {
              if (botao.botao_filho && botao.botao_filho.ativo) {
                self.botoes[i] = botao.botao_filho;
                i++;
              }
            });

            self.botoes = self.botoes.sort((a, b) => a.ordem - b.ordem);

            if (self.botoes.length) {
              self.doubleClick = false;
              self.$loading(false);
              return;
            }
          }
          self.$loading(false);
          self.iniciarColetaOuSenha(id);
        })
        .catch((error) => {
          self.$loading(false);
          self.login(); // Tenta logar novamente em caso de erro (ex: token expirado)
          self.cancelar(); // Volta para a tela inicial para evitar travamento
        });
    },
    getBotoesFilhos: function (id, preferencial, prefixo, concatena) {
      const self = this;
      const api =
        self.$store.state.api +
        `botoes_totens?paginated=false&with[]=botao_filho&with[]=botao_filho.perguntasQuestionario.alternativasAtivas&botao_pai_id=${id}`;

      self.primeira_tela++;

      // CLIQUE 1: Define prefixo do pai e salva se ele permite concatenar
      if (self.primeira_tela === 1) {
        self.prefixo = prefixo || "";
        self.prefixo_concatena = concatena; // Se concatena do pai = 0, não concatena com filho
      }
      // CLIQUE 2: Concatena prefixo do primeiro filho APENAS se o pai permite
      else if (self.primeira_tela === 2) {
        if (self.prefixo_concatena && prefixo) {
          self.prefixo += prefixo;
        }
      }
      // CLIQUE 3+: NÃO altera mais o prefixo

      if (preferencial > self.prioridade_atual) {
        self.prioridade_atual = preferencial;
      }

      self.botoes = [];

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          if (response.data.data.length) {
            let i = 0;
            response.data.data.forEach((botao) => {
              if (botao.botao_filho && botao.botao_filho.ativo) {
                self.botoes[i] = botao.botao_filho;
                i++;
              }
            });

            self.botoes = self.botoes.sort((a, b) => a.ordem - b.ordem);

            if (self.botoes.length) {
              self.doubleClick = false;
              self.$loading(false);
              return;
            }
          }
          self.$loading(false);

          self.iniciarColetaOuSenha(id);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    alternarAlternativa: function (alternativaId) {
      const self = this;
      const pergunta = self.perguntaAtual;

      if (!pergunta) {
        return;
      }

      const selecionadas = (self.respostasPorPergunta[pergunta.id] || []).slice();

      if (pergunta.selecao === "unica") {
        self.$set(
          self.respostasPorPergunta,
          pergunta.id,
          selecionadas.includes(alternativaId) ? [] : [alternativaId]
        );
        return;
      }

      const indice = selecionadas.indexOf(alternativaId);

      if (indice === -1) {
        selecionadas.push(alternativaId);
      } else {
        selecionadas.splice(indice, 1);
      }

      self.$set(self.respostasPorPergunta, pergunta.id, selecionadas);
    },
    avancarPergunta: function () {
      const self = this;

      if (!self.podeAvancarPergunta) {
        return;
      }

      if (self.ehUltimaPergunta) {
        self.confirmarQuestionario();
        return;
      }

      self.indicePerguntaAtual += 1;
    },
    voltarPergunta: function () {
      const self = this;

      if (self.indicePerguntaAtual > 0) {
        self.indicePerguntaAtual -= 1;
      }
    },
    confirmarQuestionario: function () {
      const self = this;
      self.abreSenha(
        self.botaoSelecionado.id,
        self.prioridade_atual,
        self.prefixo
      );
    },
    resetQuestionario: function () {
      const self = this;
      self.botaoSelecionado = null;
      self.perguntasDoQuestionario = [];
      self.indicePerguntaAtual = 0;
      self.respostasPorPergunta = {};
    },
    iniciarColetaOuSenha: function (id) {
      const self = this;
      const botao = self.botaoSelecionado;
      const perguntas = (
        (botao && botao.perguntas_questionario) ||
        []
      ).filter(
        (pergunta) =>
          pergunta.ativo !== 0 &&
          (pergunta.alternativas_ativas || pergunta.alternativas || []).length
      );

      if (perguntas.length) {
        self.perguntasDoQuestionario = perguntas;
        self.indicePerguntaAtual = 0;
        self.respostasPorPergunta = {};
        self.step = 4;
        return;
      }
      self.abreSenha(id, self.prioridade_atual, self.prefixo);
    },
    montaRespostasDoQuestionario: function () {
      const self = this;

      return self.perguntasDoQuestionario
        .map((pergunta) => ({
          pergunta_id: pergunta.id,
          alternativas: self.respostasPorPergunta[pergunta.id] || [],
        }))
        .filter((resposta) => resposta.alternativas.length);
    },
    abreSenha: function (id, prioridade, prefixo) {
      const self = this;
      const api = self.$store.state.api + "cria_senha";

      if (self.doubleClick) {
        return;
      }

      self.doubleClick = true;

      self.stepReset();

      axios
        .post(api, {
          botao_id: id ? id : null,
          cpf: self.document.cpf,
          prioridade: prioridade,
          documento: self.document,
          impressora: self.totem.impressora,
          setor_id: self.setor_id,
          prefixo: self.prefixo,
          agenda: self.agendaSetada,
          questionario: self.montaRespostasDoQuestionario(),
        })
        .then((response) => {
          self.senhaGerada = response.data;

          self.imprimeSenha(self.senhaGerada);

          self.step = 3;
          self.getBotoesTotems();

          setTimeout(function () {
            self.step =
              self.totem.disposicao === 2 ? 0 : self.totem.tempo ? 0 : 1;
            self.alterar = false;
          }, self.totem.timeout);

          self.documento = "";
          self.document = [];
          self.prioridade_atual = 1;
          self.prefixo = "";
          self.prefixo_concatena = 1;
          self.tipoDoc = "cpf";

          self.agendaSetada = null;

          self.resetQuestionario();

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");

          self.documento = "";
          self.document = [];
          self.prioridade_atual = 1;
          self.prefixo = "";
          self.prefixo_concatena = 1;

          self.resetQuestionario();

          self.doubleClick = false;

          self.$loading(false);
        });
    },
    imprimeSenha: function (senha) {
      const self = this;
      const api = self.totem.url_impressao + "/imprimir";

      self.$loading(false);

      let json_impressao = {
        URL_QRCODE: senha.url,
        SAUDACAO: senha.mensagem,
        DATA_HORA: senha.data,
        SENHA: senha.prefixo + senha.senha,
        SETOR: senha.setor,
        IMPRESSORA: self.totem.impressora,
        QR: senha.qr,
      };

      axios.post(api, json_impressao).catch((error) => {
        self.$message(
          null,
          "Serviço de impressão não disponível neste equipamento, favor verificar.",
          "info"
        );
        self.$loading(false);
      });
    },
    cancelar: function () {
      const self = this;

      self.resetQuestionario();

      self.$loading(true);

      self.step = self.totem.disposicao === 2 ? 0 : self.totem.tempo ? 0 : 1;
      self.modalOpen = false;
      self.identifing = false;
      self.document = [];
      self.documento = "";
      self.alterar = false;
      self.prioridade_atual = 1;
      self.prefixo = "";
      self.prefixo_concatena = 1;
      self.primeira_tela = 0;
      self.tipoDoc = "cpf";

      self.getBotoesTotems();

      self.$loading(false);
    },
    getHorario: function () {
      const self = this;

      setInterval(() => {
        const date = new Date();
        let ano = date.getFullYear();
        let mes = date.getMonth() + 1;
        let dia = date.getUTCDate();
        let horas = date.getHours();
        let minutos = date.getMinutes();
        let segundos = date.getSeconds();

        self.hora =
          horas.toString().padStart(2, "0") +
          ":" +
          minutos.toString().padStart(2, "0") +
          ":" +
          segundos.toString().padStart(2, "0");
        self.data =
          dia.toString().padStart(2, "0") +
          "/" +
          mes.toString().padStart(2, "0") +
          "/" +
          ano;
      }, 1000);
    },
    getConfiguracao: function () {
      const self = this;
      axios
        .get(self.$store.state.api + "configuracoes/")
        .then((response) => {
          const config = response.data.data[0];
          self.configuracao = config;
          self.$store.commit("setConfiguracaoCache", config);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDocumento: function (documento) {
      // Sempre que é digitado algo no totem, aqui é chamado
      const self = this;

      if (documento != "Enter") {
        // Acumula apenas dígitos e limita a 15 caracteres (máximo do CNS)
        if (/^\d$/.test(documento)) {
          self.documento += documento;
          self.documento = self.documento.substring(0, 15);
        }

        self.tipoDoc = "cpf";
      } else {
        let api = self.$store.state.api + "get-cpf";
        self.$loading(true);

        // Garante que só os primeiros 15 dígitos são enviados
        self.documento = self.documento.replace(/\D/g, "").substring(0, 15);

        if (self.documento.length > 11) {
          self.tipoDoc = "CNS";
        }

        axios
          .post(api, { documento: self.documento, tipoDocumento: self.tipoDoc })
          .then((response) => {
            self.stepReset();

            console.log("dsadasdas", response.data);

            if (response.data === 500 || !response.data) {
              self.documento = "";
              // self.$message("Atenção!", "CPF não encontrado", "warning");
              self.$loading(false);
              return;
            }

            // Prioridade: agendamento
            if (response.data.agendamento && response.data.agendamento.length) {
              self.agenda = response.data.agendamento;
              self.identifing = false;
              self.$loading(false);
              $("#modalAgenda").modal("toggle");
              return;
            }

            self.document = response.data.pessoa.content;

            if (self.document.dataNascimento) {
              self.document.dataNascimento = self.document.dataNascimento
                ? self.document.dataNascimento.split("T")[0]
                : null;
            }

            self.identifing = false;

            if (self.totem.disposicao === 2) {
              $("#infoPessoa").modal("toggle");
              self.modalOpen = true;

              self.step++;
            }
            self.$loading(false);
          })
          .catch((error) => {
            // self.$message("Atenção!", "CPF não encontrado", "warning");
            self.documento = "";
            self.$loading(false);
          });
      }
    },
    getPessoa: function () {
      const self = this;
      const api = self.$store.state.api + "get-cpf";

      self.mock = {
        cep: "",
        tipo: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        municipio: "",
        uf: "",
        telefone: "",
      };

      self.$loading(true);
      self.stepReset();

      let tipoDoc =
        self.documento.replace(/\D/g, "").length > 11 ? "cns" : "cpf";

      axios
        .post(api, { documento: self.documento, tipoDocumento: tipoDoc })
        .then((response) => {
          self.search = false;
          self.stepReset();

          self.document = response.data.pessoa.content
            ? response.data.pessoa.content
            : {};

          // self.mock = {
          //   cep: response.data.cep,
          //   tipo: response.data.tipo ? response.data.tipo : "RESIDENCIAL",
          //   logradouro: response.data.logradouro,
          //   numero: response.data.numero,
          //   complemento: response.data.complemento
          //     ? response.data.complemento
          //     : "",
          //   bairro: response.data.bairro,
          //   municipio: response.data.cidade,
          //   uf: response.data.estado,
          //   telefone: response.data.telefone ? response.data.telefone : "",
          // };

          self.identifing = false;

          if (self.totem.disposicao === 2) {
            console.log("4");
            if (response.data.agendamento.length) {
              console.log("tem agendamento");
              self.agenda = response.data.agendamento;
              $("#modalAgenda").modal("toggle");
            } else if (response.data.status == 200) {
              console.log("tem pessoa");
              $("#infoPessoa").modal("toggle");
              self.modalOpen = true;
              self.step++;
            } else if (response.data.status != 200) {
              console.log("não encontrado");
              self.$message("Atenção!", "CPF não encontrado", "warning");
              self.documento = "";
            }
          } else if (self.totem.disposicao === 1) {
            console.log("5");
            if (response.data.agendamento.length) {
              console.log("tem agendamento");
              self.agenda = response.data.agendamento;
              $("#modalAgenda").modal("toggle");
            } else if (response.data.status == 200) {
              console.log("tem pessoa");
              $("#infoPessoa").modal("toggle");
              self.modalOpen = true;
            } else if (response.data.status != 200) {
              console.log("nao tem pessoa");
              self.$message("Atenção!", "CPF não encontrado", "warning");
              self.documento = "";
            }
          }

          self.$loading(false);
        })
        .catch((error) => {
          self.search = false;
          self.$loading(false);
          // self.getAgenda();

          // self.$message("Atenção!", "CPF não encontrado", "warning");
          self.documento = "";
        });
    },
    getAgenda: function () {
      const self = this;
      const api = self.$store.state.api + "agenda";
      self.stepReset();

      axios
        .post(api, { cpf: self.documento })
        .then((response) => {
          self.stepReset();
          if (response.data.length) {
            self.agenda = response.data;
            $("#modalAgenda").modal("toggle");
            $("#infoPessoa").modal("toggle");
          }
          self.$loading(false);
        })
        .catch(() => {
          self.$loading(false);
          self.$message("Atenção!", "Nenhuma consulta agendada", "info");
        });
    },
    async iniciarCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        this.$refs.camera.srcObject = stream;
        this.$refs.camera2.srcObject = stream;
      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);
      }
    },
    tirarFoto() {
      const self = this;
      const video = this.$refs.camera;
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");

      self.reconhecido = false;
      self.carregando = true;
      self.$loading(true);

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      self.fotoUrl = canvas.toDataURL("image/png");

      const api = self.$store.state.api + "reconhecimento-facial";

      axios
        .post(api, { pessoa: self.document, foto: self.fotoUrl })
        .then((response) => {
          if (response.data.reconhecido) {
            $("#reconhecimentoFacial").modal("hide");
            self.pessoaPresente(this.agendaAtual);
          } else {
            self.carregando = false;
            self.reconhecido = true;

            setTimeout(() => {
              self.reconhecido = false;
              self.carregando = false;
            }, 3000);
          }
          self.carregando = false;

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);

          self.carregando = false;
          self.$message(null, error.response.data, "error");
        });
    },
    reconhecer: function (data) {
      const self = this;

      $("#reconhecimentoFacial").modal("toggle");

      self.iniciarCamera();
      self.agendaAtual = data;
    },
    getFacial: function () {
      const self = this;

      self.reconhecido = false;
      self.carregando = false;

      self.iniciarCamera();
    },
    identificarFoto: function () {
      const self = this;
      const video = this.$refs.camera2;
      const canvas = this.$refs.canvas2;
      const context = canvas.getContext("2d");

      self.mock = {
        cep: "",
        tipo: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        municipio: "",
        uf: "",
        telefone: "",
      };

      self.reconhecido = false;
      self.carregando = true;
      self.$loading(true);

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      self.fotoUrl = canvas.toDataURL("image/png");

      const api = self.$store.state.api + "reconhecimento-facial";

      axios
        .post(api, { foto: self.fotoUrl })
        .then((response) => {
          if (response.data.reconhecido) {
            $("#reconhecimentoFacial2").modal("hide");

            self.documento = response.data.texto;
            self.tipoDoc = "cpf";

            self.document = response.data.pessoa;
            self.document.nomeMae = response.data.pessoa.nome_mae;
            self.document.nomePai = response.data.pessoa.nome_pai;

            self.mock = {
              cep: response.data.pessoa.cep,
              tipo: response.data.pessoa.tipo
                ? response.data.tipo
                : "RESIDENCIAL",
              logradouro: response.data.pessoa.logradouro,
              numero: response.data.pessoa.numero,
              complemento: response.data.pessoa.complemento
                ? response.data.complemento
                : "",
              bairro: response.data.pessoa.bairro,
              municipio: response.data.pessoa.cidade,
              uf: response.data.pessoa.estado,
              telefone: response.data.pessoa.telefone
                ? response.data.telefone
                : "",
            };
          } else {
            self.carregando = false;
            self.reconhecido = true;

            setTimeout(() => {
              self.carregando = false;
              self.reconhecido = false;
            }, 3000);
          }

          self.identifing = false;
          self.carregando = false;

          if (self.totem.disposicao === 2) {
            $("#infoPessoa").modal("toggle");
            self.modalOpen = true;

            self.step++;
          }

          self.$loading(false);
        })
        .catch((error) => {
          self.carregando = false;
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    pessoaPresente: function (data) {
      const self = this;
      const api = self.$store.state.api + "agendamentos/" + data.id;

      self.setor_id = data.setor_id;

      data._method = "PUT";
      data.json = null;
      data.status = 3;
      self.document.cpf = data.cpf;

      self.agendaSetada = data;

      console.clear();
      self.getPessoaFromDatabase(data.cpf);

      setTimeout(() => {
        self.abreSenha(0, self.prioridade_atual, data);
      }, 2300);

      self.stepReset();
      setTimeout(() => {
        axios
          .post(api, data)
          .then((response) => {
            console.log(self.prioridade_atual);
            self.$loading(false);
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
            self.$loading(false);
          });
      }, 100);
    },
    getPessoaFromDatabase: function (cpf) {
      const self = this;
      const api = self.$store.state.api + "pessoas?cpf=" + cpf;

      // setTimeout(() => {
      //   self.$loading(true);
      // }, 300);

      axios
        .get(api)
        .then((response) => {
          let idade = response.data.data[0]
            ? response.data.data[0].diff_idade
            : 1;

          self.document = response.data.data[0];
          self.$loading(false);
          // self.prioridade_atual = 1;

          // if (idade < 60) {
          //   self.prioridade_atual = 1;
          // }

          // if (idade > 60 && idade < 80) {
          //   self.prioridade_atual = 2;
          // }

          // if (idade >= 80) {
          //   self.prioridade_atual = 3;
          // }
        })
        .catch(() => {
          self.prioridade_atual = 1;
          self.$loading(false);
        });
    },
    sendMessage: function () {
      const self = this;
      const api =
        self.$store.state.api + "update-register/55" + self.mock.telefone;

      self.stepReset();

      axios
        .get(api)
        .then((response) => {
          self.stepReset();

          self.alterar = false;
          self.mock.telefone = "";

          self.$message("Atenção!", "Mensagem enviada!", "info");
          self.getAgenda();
        })
        .catch(() => {
          self.$message("Atenção!", "Erro ao enviar a mensagem", "info");
        });
    },
    inputDoc: function (number) {
      const maxLength = this.tipoDoc === "cpf" ? 11 : 15;

      if (this.documento.length < maxLength) {
        this.documento += number;
      }

      // Garante o limite
      this.documento = this.documento.substring(0, maxLength);
    },
    deleteDoc: function () {
      this.documento = this.documento.slice(0, -1);
      // Removido o auto-toggle para manter o tipo selecionado pelo usuário
    },
    stepReset: function () {
      const self = this;

      clearTimeout(self.reset);
      self.modalOpen = false;
      self.timer = 0;

      if (self.totem.tempo) {
        self.reset = setTimeout(() => {
          self.timer = 0;
          self.getBotoesTotems();
          self.cancelar();
          $("#modalAgenda").modal("hide");
          $("#infoPessoa").modal("hide");
        }, self.totem.tempo * 1000);
      }
    },
    resetClickCount() {
      clearTimeout(this.clickTimeout);
      this.clickCount = 0;
    },
    cancelHold() {
      clearTimeout(this.holdTimeout);
    },
    reload() {
      location.reload();
    },
    clickLogo: function () {
      const self = this;
      self.clickCount++;

      if (self.clickCount === 1) {
        self.clickTimeout = setTimeout(() => {
          self.resetClickCount();
        }, 1000);
      }

      if (self.clickCount >= 5) {
        clearTimeout(self.clickTimeout);
        self.reload();
        self.resetClickCount();
      }
    },
    getPesquisa: function () {
      const self = this;

      self.modalLoaded = false;

      setTimeout(() => {
        self.modalLoaded = true;
      }, 200);

      setTimeout(() => {
        $("#pesquisa_satisfacao").modal("show");
      }, 500);
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.$message("Sucesso", "Totem iniciado e serviços online.", "success");

    self.getConfiguracao();
    self.getHorario();

    if (id) {
      self.getTotem(id); // já chama getBotoesTotems() internamente
    } else {
      self.searchTotem(); // já chama getTotem() que chama getBotoesTotems()
    }

    $(document).keydown(function () {
      self.getDocumento(event.key);
      self.stepReset();
    });

    setInterval(() => {
      if (self.step !== 0 && !self.modalOpen) {
        self.timer++;
      }

      if (self.modalOpen) {
        clearTimeout(self.reset);
      }
    }, 1000);

    // setInterval(() => {
    //   self.getTotem(id);
    // }, 60000);

    $(document).click(function () {
      self.stepReset();
    });
  },
  created() {},
};
</script>

<style>
html,
body {
  font-family: helvetica;
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation: fadeIn 1.3s ease-in-out;
  -moz-animation: fadeIn 1.3s ease-in-out;
  -o-animation: fadeIn 1.3s ease-in-out;
  animation: fadeIn 1.3s ease-in-out;
}

body {
  overflow-x: hidden;
}

div > #mensagens {
  display: relative;
  width: 200%;
  grid-template-columns: repeat(2, 0.25fr);
  justify-content: space-between;
  transform: translateX(100z);
  animation: anima 90s linear infinite;
}

#mensagens:before,
#mensagens:after {
  content: "";
  display: relative;
}

#mensagens:after {
  transform: translate3d(100%, 0, 0);
}

@keyframes anima {
  from {
    transform: translateX(110%);
  }

  to {
    transform: translateX(-160%);
  }
}
.btn-border {
  border: 1px solid rgb(170, 170, 170);
  border-radius: 5px;
}
.btn-comum {
  background-color: rgb(15, 121, 219);
  border-radius: 5px;
  color: white;
  height: 105px;
  font-weight: bold;
  font-size: 20px;
}
.btn-preferencial {
  background-color: rgb(207, 142, 2);
  border-radius: 5px;
  color: white;
  height: 105px;
  font-weight: bold;
  font-size: 20px;
}
.btn-preferencial80 {
  background-color: rgb(214, 0, 0);
  border-radius: 5px;
  color: white;
  height: 105px;
  font-weight: bold;
  font-size: 20px;
}
</style>
